/**
 * Non-prospect email domains (ORB-619) — people who are ours, the customer's own staff, or a
 * division that shares the account. They are still created as leads and their engagement is still recorded;
 * the domains drive a flag, and the flag drives what the audience views show and count.
 *
 * The same shape serves both levels (client company and workspace) so one editor covers both.
 * Wire casing is PascalCase, as everywhere else in the API.
 */

/** Which level owns an inherited entry. Values mirror the API's snake_case source discriminators. */
export type InheritedNonProspectDomainSource = 'client_company' | 'managing_company'

export interface InheritedNonProspectDomain {
  Host: string
  Source: InheritedNonProspectDomainSource
  /** Display name of the owning company, so the badge can say whose entry it is. */
  SourceName: string | null
}

export interface NonProspectDomainsViewDto {
  ETag: string
  /** This level's own editable entries. */
  NonProspectDomains: string[]
  /** In force here but owned above — read-only, shown with a source badge. */
  InheritedDomains: InheritedNonProspectDomain[]
}

export interface NonProspectDomainsUpdateDto {
  /** Omit to leave unchanged; an empty array clears the list. */
  NonProspectDomains?: string[]
  ETag: string
}

/** Server-side cap per level (mirrors NonProspectDomainValidationConstants.MaxCount). */
export const NON_PROSPECT_DOMAINS_MAX_COUNT = 50
